import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EcommLipstickIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M9 21.5H15C15.2761 21.5 15.5 21.2762 15.5 21V15.5H8.5V21C8.5 21.2762 8.72386 21.5 9 21.5ZM9 23C7.89543 23 7 22.1046 7 21V15C7 14.4478 7.44772 14 8 14H16C16.5523 14 17 14.4478 17 15V21C17 22.1046 16.1046 23 15 23H9Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            d="M8.25 11C8.25 10.0335 9.0335 9.25005 10 9.25005H14C14.9665 9.25005 15.75 10.0335 15.75 11V15H14.25V11C14.25 10.862 14.1381 10.75 14 10.75H10C9.86193 10.75 9.75 10.862 9.75 11V15H8.25V11zM10.7947 5.19199C11.2037 5.08043 11.7599 4.77572 12.2929 4.24269 12.8259 3.70965 13.1306 3.15352 13.2422 2.74446 13.2645 2.6626 13.2774 2.59647 13.2845 2.54395 13.232 2.55103 13.1659 2.56395 13.084 2.58628 12.675 2.69784 12.1188 3.00255 11.5858 3.53558 11.0528 4.06861 10.748 4.62475 10.6365 5.03381 10.6142 5.11567 10.6012 5.1818 10.5942 5.23432 10.6467 5.22724 10.7128 5.21431 10.7947 5.19199zM10.4219 5.2332C10.4219 5.2332 10.4273 5.23367 10.4363 5.23757 10.4261 5.23564 10.4219 5.2332 10.4219 5.2332zM10.5909 5.39221C10.5948 5.40118 10.5953 5.40654 10.5953 5.40654 10.5953 5.40654 10.5928 5.40235 10.5909 5.39221zM13.4567 2.54507C13.4567 2.54507 13.4514 2.5446 13.4424 2.5407 13.4526 2.54263 13.4567 2.54507 13.4567 2.54507zM13.2878 2.38606C13.2839 2.37709 13.2834 2.37172 13.2834 2.37172 13.2834 2.37172 13.2858 2.37591 13.2878 2.38606zM9.46447 6.36401C10.2455 7.14506 11.9867 6.67018 13.3536 5.30335 14.7204 3.93651 15.1953 2.19531 14.4142 1.41426 13.6332.633212 11.892 1.10809 10.5251 2.47492 9.15829 3.84176 8.68342 5.58296 9.46447 6.36401z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
          <path
            d="M9 10L9 5.00005 10.5 5.00005 10.5 10H9zM13.5 10L13.5 2.00005 15 2.00005V10H13.5z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
